/**
 * Parker
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingEntitlementStatus = {
    Included: 'Included',
    NotIncluded: 'NotIncluded',
    NotAvailable: 'NotAvailable'
} as const;
export type ParkingEntitlementStatus = typeof ParkingEntitlementStatus[keyof typeof ParkingEntitlementStatus];

